import { Link, Typography } from '@mui/material';
import { FC } from 'react';
import { Notice } from 'ui/Notice';

export const NoGpsrProductsBanner: FC = () => {
	return (
		<Notice>
			<Typography
				component="h2"
				color="primary"
				sx={{
					fontSize: '1.2rem',
				}}
			>
				No any <b>Product Types</b> added to your account yet.
				<br /> Please wait for a while or contact EAS support by email{' '}
				<Link
					sx={{
						color: 'primary',
						textDecoration: 'none',
						fontWeight: 'bold',
						'&:hover': {
							textDecoration: 'underline',
						},
					}}
					href="mailto:gpsr@easproject.com"
				>
					gpsr@easproject.com
				</Link>
			</Typography>
		</Notice>
	);
};
